export default __webpack_public_path__ + "static/media/080_finish_soso.last.514cab16.webp";